// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

import firebase from "firebase/app";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyCrds4aytQOXY4WI2gREwA8hEZNSs7eQtQ",
  authDomain: "dawsat-b2b-dashboard.firebaseapp.com",
  databaseURL: "https://dawsat-b2b-dashboard.firebaseio.com",
  projectId: "dawsat-b2b-dashboard",
  storageBucket: "dawsat-b2b-dashboard.appspot.com",
  messagingSenderId: "1055297666532",
  appId: "1:1055297666532:web:d5dd74bf38609b518c5bf1"
};
firebase.initializeApp(config);
